export default __webpack_public_path__ + "static/media/scroll-image.2df880f5.png";